import PropTypes from 'prop-types';
import React from 'react';

export default class StandingTeamStat extends React.Component {
  static propTypes = {
    team: PropTypes.object,
  };
  render() {
    const {team} = this.props;
    return (
      <li className="standing-team-stat col-xs-12">
        <div className="col-xs-12 col-lg-7 no-padding">
          <div className="team">
            <h4 className="placement">{team.placement}</h4>
            <h5>{team.team}</h5>
          </div>
        </div>
        <div className="col-xs-4 col-lg-2 no-padding">
          <div className="prize">
            <h5>{team.prize}</h5>
          </div>
        </div>
        <div className="col-xs-4 col-lg-1 no-padding">
          <div className="club">
            <img className="img-responsive" src={team.club} alt={team.name} />
          </div>
        </div>
        <div className="col-xs-4 col-lg-2 no-padding">
          <div className="points">
            <h5>{team.teamPoints}</h5>
          </div>
        </div>
      </li>
    );
  }
}
